module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-contract-363d20da.svg";